import { Font } from "opentype.js";

export default {
	state: (): object => ( {
		loading: false,
		error: null,
		fonts: [],
		selectedFontName: 'Exo-Bold',
		selectedFontObject: {},
	} ),
	mutations: {
		updateLoadingState: ( state, value ): boolean => state.loading = value,
		updateError: ( state, value ): string => state.error = value,
		setSelectedFont: ( state, value ): string => state.selectedFontName = value,
		setSelectedFontObject: ( state, value ): string => state.selectedFontObject = value,
		addFont: ( state, { fontName, font } ): void => {
			if( state.fonts.find( fontObject => fontObject.fontName === fontName ) !== undefined ) {
				return;
			}

			state.fonts.push( {
				fontName,
				font
			} );
		}
	},
	actions: {
		async loadFonts( { dispatch, getters, commit }, isCutout = false ): Promise<void> {
			const { font } = ! isCutout ? getters.modifiers : getters.cutoutModifiers;

			if ( ! getters.fontIsLoaded(font) ) {
				await dispatch( 'loadFont', font );
			}
		},
		async loadFont( { commit }, fontName ): Promise<void> {
			commit("updateLoadingState", true);

			const { default: openType } = await import( /* webpackChunkName: "OpenType" */ 'opentype.js' );

			if ( !fontName ) {
				return;
			}

			commit( 'updateError', null );

			const url = window.measurementSelectorVariables.fontDirUrl + fontName + '.ttf';

			try {

				// Docs claim this approach should work (and it seems to be the case). However, TS suggests this isn't possible.
				const font = await openType.load( url );
				commit( 'addFont', { fontName, font } );
				commit( 'setSelectedFontObject', font);
				commit("updateLoadingState", false);
			} catch( err ) {
				commit( 'updateError', err.toString() );
				commit("updateLoadingState", false);
			}
		}
	},
	getters: {
		fontIsLoaded: (state): Function => ( font: string ) => state.fonts.some( obj => obj.fontName === font ),
		fontIsLoading: ( state ): boolean => state.loading,
		getSelectedFontName: ( state ): string => state.selectedFontName,
		selectedFontObject: ( state ): object => state.selectedFontObject,
		loadedFonts: ( state ): object => state.fonts,
		getSelectedFontObject: ( state, getters ): Font|undefined => {
			const font = state.fonts.find( fontObject => fontObject.fontName === getters.getSelectedFontName );

			if ( font === undefined ) {
				return undefined;
			}

			return font.font;
		},
	}
};
